import { useEffect, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";
import { isBrowser } from "../isBrowser";

let animationFrameID = 0;
export const useResizeObserver = <T extends HTMLElement>(
  ref: React.RefObject<T | null>,
): ResizeObserverEntry | undefined => {
  const [entry, setEntry] = useState<ResizeObserverEntry>();

  useEffect(() => {
    if (!isBrowser) return;
    const element = ref.current ?? null;
    const resizeObserver = new ResizeObserver(
      (entries: ResizeObserverEntry[]) => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        animationFrameID = window.requestAnimationFrame(() => {
          setEntry(entries[0]);
        });
      },
    );
    if (element) {
      resizeObserver.observe(element);
    }

    return () => {
      if (element) {
        resizeObserver.unobserve(element);
      }
      window.cancelAnimationFrame(animationFrameID);
    };
  }, [ref]);
  return entry;
};
